import { Link } from 'react-router-dom';
import { paths } from '../../routes/paths';

import { Button } from '../ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/Dialog';
import { useEmergencyFundReviewQuery } from '../../features/snapshots/queries';
import pt from '../../locales/pt';
import { formatEUR } from '../../utils/money';

export function SelfieEmergencyFundReviewModal({ snapshotId, isOpen, onClose }) {
  const { data: review, isFetched } = useEmergencyFundReviewQuery(snapshotId, {
    enabled: isOpen && Boolean(snapshotId),
  });
  const copy = pt.emergencyFund.selfieReview;

  if (!isOpen) return null;
  if (isFetched && !review?.show_review) return null;
  if (!review) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 text-sm text-muted-foreground">
          <p>
            {copy.monthsCovered.replace('{months}', String(review.months_covered))}
          </p>
          <p>
            {copy.avgExpenses.replace(
              '{amount}',
              formatEUR(review.avg_monthly_expenses),
            )}
          </p>
          {review.expenses_above_target ? (
            <p className="rounded-lg border border-warning-500/30 bg-warning-tint p-2 text-warning-fg">
              {copy.expensesAbove}
            </p>
          ) : null}
        </div>

        <div className="flex flex-col gap-2 pt-2">
          {review.actions?.includes('review_allocations') ? (
            <Button asChild className="w-full">
              <Link to={`${paths.emergencyFundWizard}?step=allocations`} onClick={onClose}>
                {copy.reviewAllocationsCta}
              </Link>
            </Button>
          ) : null}
          <Button type="button" variant="outline" className="w-full" onClick={onClose}>
            {copy.dismissCta}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SelfieEmergencyFundReviewModal;
